import * as React from "react";
import { CopyAll } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import copy from "clipboard-copy";
import toast from "react-hot-toast";

import customer from "../../assets/images/icons/customer.png";
import menu from "../../assets/images/icons/menu.png";
import logo1 from "../../assets/images/logo/logo.png";
import { apiConnectorGet } from "../../services/apiconnector";
import { endpoint } from "../../services/urls";

const menuItems = [
  { label: "User Information", to: "/Profile", icon: "ri-user-line" },
  {
    label: "Self Transfer",
    to: "/SelfTransfer",
    icon: "ri-arrow-left-right-line",
  },
  { label: "Withdrawal", to: "/Withdrawal", icon: "ri-bank-card-line" },
  { label: "P2P Transfer", to: "/P2PTransfer", icon: "ri-swap-line" },
  // {
  //   label: "Transaction History",
  //   to: "/Dashboard",
  //   icon: "ri-exchange-line",
  //   extra: () => localStorage.setItem("lastlab", 3),
  // },
  { label: "Invite Friends", to: "/Promotion", icon: "ri-user-add-line" },
  { label: "Official Channel", to: "/Dashboard", icon: "ri-broadcast-line" },
  {
    label: "Customer Care",
    to: "/CustomerCare",
    icon: "ri-customer-service-2-line",
  },
  { label: "About Us", to: "/About", icon: "ri-information-line" },
  { label: "Download App", to: "/Dashboard", icon: "ri-download-2-line" },
];

export default function Sidebar() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const close = () => setOpen(false);

  const { data } = useQuery({
    queryKey: ["dashboard"],
    queryFn: () => apiConnectorGet(endpoint.member_details),
    enabled: !!endpoint?.member_details,
    refetchOnMount: false,
    refetchOnWindowFocus: true,
  });
  const user = data?.data?.result?.[0] || {};

  return (
    /* ── HEADER BAR ─────────────────────────────────────────────── */
    <div className="main_header flex items-center justify-between px-4 py-2 bg-[#081820] border-b border-[rgba(0,220,200,0.15)] fixed top-0 left-0 right-0 w-full z-[1200]">
      {/* ── HAMBURGER + DROPDOWN ──────────────────────────────────── */}
      <div className="relative">
        {/* Button */}
        <button
          onClick={() => setOpen((p) => !p)}
          className="border-none outline-none cursor-pointer p-0 flex items-center"
          style={{ background: "none", WebkitTapHighlightColor: "transparent" }}
        >
          <img src={menu} alt="menu" className="w-7 h-7" />
        </button>

        {open && (
          <>
            {/* Backdrop */}
            <div onClick={close} className="fixed inset-0 z-[1298]" />

            {/* Dropdown panel */}
            <div
              className="absolute top-[calc(100%+8px)] left-[-16px] z-[1299] w-64 rounded-xl bg-[#0b2030] border border-[rgba(0,220,200,0.15)] overflow-hidden"
              style={{
                boxShadow:
                  "0 12px 48px rgba(0,0,0,0.8), 0 0 14px rgba(0,160,255,0.25)",
              }}
            >
              {/* User card */}
              <div className="p-4 bg-[#081820] border-b border-[rgba(0,220,200,0.15)]">
                <div className="flex items-start justify-between">
                  {/* Avatar + name */}
                  <div className="flex items-center gap-3">
                    <div className="bg-[#00A0FF] w-8 h-8 rounded-full flex items-center justify-center text-black font-semibold">
                      {user?.lgn_name?.charAt(0)?.toUpperCase()}
                    </div>
                    <div>
                      <p className="text-[#c8f0ec] font-bold text-[13px] leading-tight">
                        {user?.lgn_name
                          ? `${user.lgn_name.substring(0, 12)}...`
                          : "—"}
                      </p>
                      <div className="flex items-center gap-1 mt-0.5">
                        <p className="text-[#00A0FF] text-[11px]">
                          UID:{" "}
                          <span className="text-[#00A0FF]">
                            {user?.lgn_cust_id}
                          </span>
                        </p>
                        <CopyAll
                          className="text-[#5ba8a0] hover:text-[#00A0FF] cursor-pointer"
                          style={{ fontSize: 13 }}
                          onClick={() => {
                            if (!user?.lgn_cust_id) return;
                            copy(user.lgn_cust_id);
                            toast.success("Copied!");
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Rank */}
                  <div className="text-right !flex !flex-col !items-center">
                    <p className="text-[#00A0FF] text-[10px]">Rank</p>
                    <p
                      className="text-[#00A0FF] font-bold text-[12px]"
                      style={{ textShadow: "0 0 8px rgba(0,160,255,0.6)" }}
                    >
                      {user?.is_bot_bought ? "D" : "---"}
                    </p>
                  </div>
                </div>

                {/* Verification badge */}
                <div className="flex items-center justify-between mt-3 px-3 py-2 rounded-xl bg-[rgba(0,160,255,0.05)] border border-[rgba(0,160,255,0.1)]">
                  <div>
                    <p className="text-[#00A0FF] text-[10px] uppercase tracking-wide">
                      Verification
                    </p>
                    {/* <p className="text-orange-400 text-[12px] font-semibold">
                      Not Certified
                    </p> */}
                  </div>
                  <i className="ri-map-pin-user-line text-[#5ba8a0] text-[18px]" />
                </div>
              </div>

              {/* Nav list */}
              <div className="p-2">
                {menuItems.map((item) => (
                  <Link
                    key={item.label}
                    to={item.to}
                    onClick={() => {
                      item.extra?.();
                      close();
                    }}
                    className="flex items-center gap-3 pr-3 pl-4 py-2.5 rounded-xl text-[#c8f0ec] hover:bg-[rgba(0,160,255,0.12)] hover:text-[#00A0FF] transition-all duration-200 mb-0.5 no-underline"
                  >
                    <i
                      className={`${item.icon} text-[#5ba8a0] text-[17px] w-5 text-center pl-1`}
                    />
                    <span className="text-[13px] font-medium pr-5 pl-1">
                      {item.label}
                    </span>
                  </Link>
                ))}

                {/* Divider */}
                <div className="my-2 border-t border-[rgba(0,220,200,0.15)]" />

                {/* Language */}
                <div className="flex items-center justify-between px-3 py-2.5 rounded-xl hover:bg-[rgba(0,160,255,0.12)] transition-all duration-200 cursor-pointer">
                  <div className="flex items-center gap-3">
                    <i className="ri-global-line text-[#00A0FF] text-[17px] w-5 text-center" />
                    <span className="text-[#00A0FF] text-[13px]">Language</span>
                  </div>
                  <span className="text-[#00A0FF] text-[11px] font-semibold px-2 py-0.5 rounded bg-[rgba(0,160,255,0.12)] border border-[rgba(0,220,200,0.15)]">
                    English
                  </span>
                </div>

                {/* Quote Currency */}
                <div className="flex items-center justify-between px-3 py-2.5 rounded-xl hover:bg-[rgba(0,160,255,0.12)] transition-all duration-200 cursor-pointer">
                  <div className="flex items-center gap-3">
                    <i className="ri-currency-line text-[#00A0FF] text-[17px] w-5 text-center" />
                    <span className="text-[#00A0FF] text-[13px]">
                      Quote Currency
                    </span>
                  </div>
                  <span className="text-[#00A0FF] text-[11px] font-semibold px-2 py-0.5 rounded bg-[rgba(0,160,255,0.12)] border border-[rgba(0,220,200,0.15)]">
                    USDT - $
                  </span>
                </div>

                {/* Divider */}
                <div className="my-2 border-t border-[rgba(0,220,200,0.15)]" />

                {/* Logout */}
                <button
                  onClick={() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate("/", { replace: true });
                    window.location.reload();
                  }}
                  className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-red-400 hover:bg-[rgba(255,82,82,0.08)] hover:text-red-300 transition-all duration-200 cursor-pointer border-none"
                  style={{
                    background: "none",
                    WebkitTapHighlightColor: "transparent",
                  }}
                >
                  <i className="ri-logout-box-r-line text-[17px] w-5 text-center" />
                  <span className="text-[13px] font-semibold">Logout</span>
                </button>
              </div>

              {/* Bottom glow strip */}
              <div
                className="h-0.5 opacity-40"
                style={{
                  background:
                    "linear-gradient(90deg, transparent, #00A0FF, transparent)",
                }}
              />
            </div>
          </>
        )}
      </div>

      <img
        src={logo1}
        alt="logo"
        className="cursor-pointer"
        style={{
          filter: "drop-shadow(0 0 8px rgba(0,160,255,0.4))",
          height: "35px",
        }}
        onClick={() => navigate("/Dashboard")}
      />
      <img
        src={customer}
        alt="support"
        className="cursor-pointer w-8 h-8"
        style={{ filter: "drop-shadow(0 0 5px rgba(0,160,255,0.5))" }}
        onClick={() => navigate("/CustomerCare")}
      />
    </div>
  );
}
